class PurchaseOrderShippingCostService extends BaseService
	@registerService()

	calculateUnitShippingCost: (totalCost, totalQuantity) ->
		totalCost = parseInt(totalCost ? 0)
		totalQuantity = parseFloat(totalQuantity ? 0)

		if totalCost == 0 || totalQuantity == 0
			return 0

		return Math.max(Math.round(totalCost / totalQuantity), 1)
